import { type CurrencyCode } from '../currencies/constants';

export type ImpressionPrice = {
  originalPrice: string;
  taxInclusiveOriginalPrice?: string;
  discountedPrice?: string;
  taxInclusiveDiscountedPrice?: string;
  currency: CurrencyCode;
};

export enum ModuleName {
  MoreFromThisSeller = 'MoreFromThisSeller',
  SimilarItems = 'SimilarItems',
  RecentlyViewed = 'RecentlyViewed',
  SearchResults = 'SearchResults',
  YouMightAlsoLike = 'YouMightAlsoLike',
}

export type ImpressionsBatcherHookArgs = {
  productId?: number;
  shouldCollectImpression?: boolean;
  moduleName?: ModuleName;
  tileType?: TileType;
  prices?: ImpressionPrice;
  position?: number;
  depopSearchId?: string;
  isEnd?: boolean;
  page?: number;
};

export enum Components {
  InCountrySearch = 'in_country_search',
}

export enum TileType {
  Organic = 'Organic',
  Boosted = 'Boosted',
}

export type Impression = {
  impressionTime: string;
  productId: number;
  tileType?: TileType;
  prices?: ImpressionPrice;
  position?: number;
  isEnd?: boolean;
  component?: string;
  page?: number;
};

/**
 * An impressions batch with an assigned event id (`baseEvent.id`), reused
 * verbatim across retries/replays so the backend can dedup it.
 */
export type PendingBatch = {
  id: string;
  impressions: Impression[];
  searchId?: string | null;
  /** Number of send attempts made so far, used to cap retries. */
  attempts: number;
};
